var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExitIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3696 33.3028C49.3825 33.2757 49.3942 33.2482 49.405 33.2198C49.4226 33.1739 49.4367 33.1272 49.4484 33.0797C49.4551 33.0538 49.4626 33.0284 49.4676 33.0021C49.4818 32.9266 49.4905 32.8502 49.4905 32.7735C49.4905 32.6968 49.4814 32.6204 49.4676 32.5449C49.4626 32.5182 49.4551 32.4932 49.4484 32.4673C49.4363 32.4198 49.4226 32.3731 49.405 32.3272C49.3942 32.2988 49.3821 32.2713 49.3692 32.2442C49.35 32.2029 49.3279 32.1633 49.3041 32.1241C49.2878 32.0978 49.272 32.0715 49.254 32.0465C49.2457 32.0352 49.2403 32.0227 49.2315 32.0114L44.3476 25.653C43.9267 25.1054 43.1405 25.0019 42.5928 25.4232C42.0451 25.8441 41.9417 26.6299 42.363 27.178L45.7007 31.5218H26.2396C25.5485 31.5218 24.9883 32.0819 24.9883 32.7731C24.9883 33.4642 25.5485 34.0244 26.2396 34.0244H45.7003L42.363 38.3682C41.9417 38.9163 42.0447 39.7017 42.5928 40.123C42.8201 40.2977 43.0883 40.382 43.3544 40.382C43.7298 40.382 44.1011 40.2139 44.3476 39.8931L49.2319 33.5356C49.2407 33.5243 49.2465 33.5118 49.2549 33.5001C49.2728 33.4751 49.2882 33.4492 49.3045 33.4234C49.3283 33.3837 49.3504 33.3441 49.3696 33.3028Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.561 51.5398H17.2513C16.5602 51.5398 16 50.9797 16 50.2885V15.2513C16 14.5602 16.5602 14 17.2513 14H38.561C39.2522 14 39.8124 14.5602 39.8124 15.2513V27.7871C39.8124 28.4783 39.2522 29.0385 38.561 29.0385C37.8699 29.0385 37.3097 28.4783 37.3097 27.7871V16.5027H18.5027V49.0372H37.3097V37.1955C37.3097 36.5043 37.8699 35.9441 38.561 35.9441C39.2522 35.9441 39.8124 36.5043 39.8124 37.1955V50.2885C39.8124 50.9797 39.2526 51.5398 38.561 51.5398Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExitIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exit-icon.b3869bb501ef2b466693674294a001b2.svg";